// To be deleted once all calculators are done with currency tier-1 adoptions
// Dependencies

import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

// Local components.
import Panel from './panel/panel';

// CSS
require('./two-panel-container.less');

const TwoPanelContainer = (props) => {
  const primaryPanelStyle = {};
  const secondaryPanelStyle = {};

  if (props.orientation === 'horizontal') {
    primaryPanelStyle.width = props.split;
    secondaryPanelStyle.width = `${100 - parseInt(props.split, 10)}%`;
  }

  return (
    <div
      className={classnames(
        'two-panel-container',
        props.orientation,
        props.className
      )}
    >
      <Panel style={primaryPanelStyle} {...props.primaryPanelProps} />
      <Panel style={secondaryPanelStyle} {...props.secondaryPanelProps} />
    </div>
  );
};

TwoPanelContainer.displayName = 'TwoPanelContainer';

TwoPanelContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  orientation: PropTypes.string,
  primaryPanelProps: PropTypes.object,
  secondaryPanelProps: PropTypes.object,
  split: PropTypes.string,
  style: PropTypes.object,
};

TwoPanelContainer.defaultProps = {
  orientation: 'horizontal',
  primaryPanelProps: {},
  secondaryPanelProps: {},
  split: '50%',
  style: {},
  children: null,
  className: null,
};

export default TwoPanelContainer;
